import Twig from 'twig';

const render = (template: string, view: object) => {

	Twig.extendFilter('toJson', (value: string) => {
		return JSON.stringify(value)
			.replaceAll(',', '{/{comma}/}')
			.replaceAll('"', '{/{quote}/}')
			.replaceAll(`'`, '{/{quote}/}');
	});

	const result = Twig.twig({ data: template, }).render(view);
	return result;
};

export interface IUseRenderFromTamplateProps {
	template: string;
	view: object;
}

export default function useRenderFromTemplate({
	template,
	view,
}: IUseRenderFromTamplateProps) {
	try {
		return render(template, view);
	} catch (error) {
		return '';
	}
}
